export class FetchReportingProviders {
  public static readonly type = '[ReportingProviders] Fetch Reporting Providers';
}
